import { GetListRequestParams, GetListResponse, instance } from "libs/api";

import { NotificationsListItem } from "../../notifications.types";
import { ApiRoutesNotifications } from "./../../constants";

export const requestGetNotifications = async (
  params: GetListRequestParams
): Promise<GetListResponse<NotificationsListItem>> => {
  return await instance.get(ApiRoutesNotifications.Notifications, {
    params
  });
};
